import { render, staticRenderFns } from "./ResearchMultiPlot.vue?vue&type=template&id=23b29ca7"
import script from "./ResearchMultiPlot.vue?vue&type=script&lang=js"
export * from "./ResearchMultiPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchMultiPlot.vue?vue&type=style&index=0&id=23b29ca7&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b29ca7')) {
      api.createRecord('23b29ca7', component.options)
    } else {
      api.reload('23b29ca7', component.options)
    }
    module.hot.accept("./ResearchMultiPlot.vue?vue&type=template&id=23b29ca7", function () {
      api.rerender('23b29ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMultiPlot.vue"
export default component.exports